import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import ResponsiveTooltip from 'components/ResponsiveTooltip';
import styles from './style.module.less';
const CircleButton = ({ tooltip, tooltipPlacement, content, onClick, className, id, }) => (_jsx(ResponsiveTooltip, { title: tooltip, placement: tooltipPlacement, children: _jsx("button", { type: "button", id: id, className: clsx(styles.circleButton, className), onClick: onClick, children: content }) }));
export default CircleButton;
